$(document).ready(function(){
  $(".faq_que").click(function(){
		$(this).next(".faq_ans").slideToggle();
    	$(this).toggleClass("faq_open");
  });  
  $(document).on('click', '.buttoncont input, .addtocart' ,function(){
    setTimeout(function(){
  		$("a.site-header__cart-toggle").trigger("click");
    }, 500);
  });
  
  $(document).on('click', '#header #cart .cartitems, #mobile-header .cartitems' ,function(event){
      event.preventDefault();
      $("a.site-header__cart-toggle").trigger("click");
  });
  
  $(document).on('click', '.keep_shopping', function(event){
      event.preventDefault();
      $(".drawer__close").trigger("click");
  });  

  //".productdetail .product-form").attr("data-cart-submit","sure");
});
